import { Link } from 'react-router-dom'
import { useTheme } from '../hooks/useTheme'

// styles
import './CardList.css'

export default function LessonList({ lessons }) {
    const { mode } = useTheme()



    return (
        <div className='card-list'>
            {lessons.map(lesson => (
                <div key={lesson.id} className={`card ${mode}`}>
                    <h3>{lesson.title}</h3>
                    <div className='icon-container'>
                        <img src={lesson.icon} alt={`${ lesson.title} icon`} className="card-icon"/>
                    </div>
                    <div className='date'>{lesson.date}</div>
                    <div className='date'>Grades: {lesson.grade}</div>
                    <Link to={`/lesson-plan/${lesson.id}`}>Learn More</Link>
                </div>
            ))}
        </div>
    )
}